import { render, staticRenderFns } from "./TestApply.vue?vue&type=template&id=2d019247&scoped=true&"
import script from "./TestApply.vue?vue&type=script&lang=js&"
export * from "./TestApply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d019247",
  null
  
)

export default component.exports